// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel, AppConfigService, EnvironmentType } from 'common';

export const environmentConfigurationMap: EnvironmentModel[] = [
  {
    production: false,
    apiDomain: 'localhost:61566',
    appInsights: {
      instrumentationKey: '88f1eca6-295a-4e62-a5b8-9c92fd2a7507'
    },
    apiEndpoint: 'http://localhost:61566/',
    scope: 'ctt.api',
    spaUrl: 'http://localhost:4203',
    clientId: 'CTT_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.Development,
    identityProvider: {
      authorityUrl: 'http://localhost:43782/'
    },
    userManagement: false
  },
  {
    production: true,
    apiDomain: 'ishare-qatest-conformancetool.azurewebsites.net/',
    appInsights: {
      instrumentationKey: '6d25ec47-77fa-488f-947c-365d74f23464'
    },
    apiEndpoint: '/',
    scope: 'ctt.api',
    spaUrl: 'https://ishare-qatest-conformancetool.azurewebsites.net/',
    clientId: 'CTT_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.QATest,
    identityProvider: {
      authorityUrl: 'https://ishare-qatest-schemeowner.azurewebsites.net/'
    },
    userManagement: false
  },
  {
    production: true,
    apiDomain: 'ctt.isharetest.net',
    appInsights: {
      instrumentationKey: '1341bf56-5a99-4f77-9385-d2acbffe6e46'
    },
    apiEndpoint: '/',
    scope: 'ctt.api',
    spaUrl: 'https://ctt.isharetest.net',
    clientId: 'CTT_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.Test,
    identityProvider: {
      authorityUrl: 'https://scheme.isharetest.net/'
    },
    userManagement: false
  },
  {
    production: true,
    apiDomain: 'ctt.n5.isharetest.net',
    appInsights: {
      instrumentationKey: '23cd24dc-20d9-4c8b-9fd6-a1fcdf356999'
    },
    apiEndpoint: '/',
    scope: 'ctt.api',
    spaUrl: 'https://ctt.n5.isharetest.net',
    clientId: 'CTT_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.n5Test,
    identityProvider: {
      authorityUrl: 'https://scheme.n5.isharetest.net/'
    },
    userManagement: false
  },
  {
    production: true,
    apiDomain: 'schemeowner-ctt.azurewebsites.net',
    appInsights: {
      instrumentationKey: 'a0b464cb-7637-4eb2-a684-58e3eb534b76'
    },
    apiEndpoint: '/',
    scope: 'ctt.api',
    spaUrl: 'https://schemeowner-ctt.azurewebsites.net',
    clientId: 'CTT_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.Live,
    identityProvider: {
      authorityUrl: 'https://so.ishareworks.org/'
    },
    userManagement: false
  }
];

export function environmentFactory() {
  const configService = new AppConfigService(environmentConfigurationMap, environmentConfigurationMap[0]);
  return configService.get();
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
